import { configureStore } from "@reduxjs/toolkit";
import websiteReducer from "./features/websiteSlice";
import defaultOrderReducer from "./features/defaultOrderSlice";
import pendingOrderReducer from "./features/pendingOrderSlice";
import customerProfileReducer from "./features/customerProfileSlice";
import keyDataReducer from "./features/keyDataSlice";
import shopSlice from './features/shopSlice'; // Import storeSlice
import todayRateReducer from './features/todayRateSlice';

//store
const store = configureStore({
  reducer: {
    website: websiteReducer,
    defaultOrder: defaultOrderReducer,
    pendingOrder: pendingOrderReducer,
    keyData: keyDataReducer,
    customerProfile : customerProfileReducer,
    todayRate: todayRateReducer,
    shop: shopSlice, // Add storeSlice
  },
});

export default store;
